import React from "react";
import PropTypes from "prop-types";

import {useFormik} from "formik";
import {ResponsiveStepperDialog} from "../../../components/ResponsiveStepperDialog";
import {DateFormatter} from "../../../services/date";

import StepApartment from "./StepApartment";
import StepOffer from "./StepOffer";
import StepDescription from "./StepDescription";
import StepSummary from "./StepSummary";

import OfferService from "../../../services/offers";

const steps = ['Struttura', 'Offerta', 'Descrizione', 'Verifica'];
const validationSchemas = [
    OfferService.validators.schemaStepApartment,
    OfferService.validators.schemaStepOffer,
    OfferService.validators.schemaStepDescription,
    OfferService.validators.schemaOffer
];

const OfferForm = props => {
    const {homes, initialValues, isEditMode, onSave, onClose} = props;
    const [isSaving, setIsSaving] = React.useState(false);
    const [activeStep, setActiveStep] = React.useState(0);
    const isLastStep = activeStep === steps.length - 1;

    const title = isEditMode ? "Modifica offerta" : "Nuova offerta";

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchemas[activeStep],
        validateOnMount: true,
        onSubmit: async (values, actions) => {
            if (isLastStep) {
                setIsSaving(true);
                // format date with iso string
                const offer = {
                    ...values,
                    startDate: DateFormatter.onlyDateISOString(values.startDate, null),
                    endDate: DateFormatter.onlyDateISOString(values.endDate, null),
                };
                await onSave(offer);
                setIsSaving(false);
            } else {
                setActiveStep(activeStep + 1);
                actions.setTouched({});
                actions.setSubmitting(false);
            }
        },
    });

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const getStepContent = () => {
        switch (activeStep) {
            case 0:
                return <StepApartment homes={homes} formik={formik} isEditMode={isEditMode}/>;
            case 1:
                return <StepOffer formik={formik} isEditMode={isEditMode}/>;
            case 2:
                return <StepDescription formik={formik}/>;
            case 3:
                return <StepSummary homes={homes} formik={formik}/>;
            default:
                throw new Error('Unknown step');
        }
    };

    const submitIsEnabled = !Object.keys(formik.errors).some(x => formik.touched[x]);

    return (
        <ResponsiveStepperDialog title={title}
                                 isOpen={true}
                                 isSaving={isSaving}
                                 activeStep={activeStep}
                                 steps={steps}
                                 enableSubmit={submitIsEnabled}
                                 onClose={onClose}
                                 onBack={handleBack}
                                 onSubmit={formik.handleSubmit}
                                 noValidate>
            {getStepContent()}
        </ResponsiveStepperDialog>
    )
};

OfferForm.propTypes = {
    homes: PropTypes.arrayOf(PropTypes.object).isRequired,
    initialValues: PropTypes.object.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
};

export default OfferForm;